import { Component, OnInit, AfterContentChecked, ChangeDetectorRef, ElementRef, ViewChild, ViewChildren, QueryList, HostListener, AfterViewChecked, Renderer2, TemplateRef } from '@angular/core';
import { SearchContractPipe } from '../Models/search-contract.pipe';
import { ContractSearchService } from '../Services/contract-search.service';
import { ContractSections, ContractDetails } from '../Models/common.model';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'app-search-contract',
    templateUrl: './search-contract.component.html',
    providers: [SearchContractPipe]
})
export class SearchContractComponent implements OnInit, AfterContentChecked, AfterViewChecked {
    private mutationObserver: MutationObserver | null = null;

    private _contractSections: ContractSections[];
    get contractSections(): ContractSections[] {
        return this._contractSections;
    }
    set contractSections(value: ContractSections[]) {
        this._contractSections = value;
    }
    contractDetails: ContractDetails;

    //activehighlightdeclaration
    filterMetadata = { count: 0 };
    index = { count: 0 };
    sectionCount = { count: 0 };
    initialLoad = true;
    expanded: boolean;
    sectionId: string;
    currentSectionId: string;
    isSectionExpanded: boolean;
    modalBody;
    popupName: string;
    toggleModalDisplay = "none";
    displayRomanListStyle: boolean;
    sectionIdStack: string[] = [];

    MatchDetails = [];

    private _searchText: string;
    get searchText(): string {
        return this._searchText;
    }
    set searchText(value: string) {
        this._searchText = value;
        this.clearFilterCount();
    }

    @ViewChildren('section') sectionHtml: QueryList<ElementRef>;
    @ViewChildren('item') itemHtml: QueryList<ElementRef>;
    @ViewChildren('format') formatHtml: QueryList<ElementRef>;

    constructor(private cdRef: ChangeDetectorRef, private element: ElementRef, private highlightCount: SearchContractPipe, private dataService: ContractSearchService, private sanitizer: DomSanitizer, private renderer2: Renderer2) {
        let w = (window as any);
        w.openPopUp = this.myfunction.bind(this)
        w.scrollSection = this.sectionScroll.bind(this)
        this.dataService.getContractDetails().subscribe((data: ContractDetails) => {
            let year = data['PageName'].replace(/[^0-9]/g, '')
            this.contractDetails = data;
            this.contractSections = data['ContractSections'];            
            this.displayRomanListStyle = year == '' ? true : year < 2020;
            this.contractSections.forEach(sec => {
                sec.ContractItems.forEach(items => {
                    items.ContractItemBodyString = this.sanitizer.bypassSecurityTrustHtml(items.ContractItemBodyString) as string
                    // items.ContractItemBody.Fragments.forEach(Fragment => { Fragment.InternalFormat = this.sanitizer.bypassSecurityTrustHtml(Fragment.InternalFormat) as string }
                    // )
                })
            })
            this.dataService.setContractAdminLink(data['ContractAdminLink']);
            this.dataService.setContractAdminLinkText(data['ContractAdminLinkText']);
            this.dataService.setSearchTextPlaceholder(data['SearchTextPlaceholder']);
        });
    }   

    ngOnInit(): void {
        this.dataService.getSearchstring$.subscribe(data => {
        this.searchText = data;
        if (this.searchText && this.searchText.trim().length > 2) {
            this.startObservingMarks();
        } else {
            this.stopObservingMarks();
        }
        });

        this.dataService.getPosition$.subscribe(data => {
        if (data > 0) this.findNext();
        else this.findPrev();
        });

        this.dataService.getExpandValue$.subscribe(data => {
        if (data === true) this.expandSections();
        });

        this.dataService.getToggleEvent$.subscribe(data => {
        this.toggleAllSections(data);
        });

        this.dataService.getQstringSectId$.subscribe(sectionId => {
        if (sectionId) {
            this.sectionId = '#' + sectionId;
            this.isSectionExpanded = true;
        }
        });
    }

    ngAfterViewChecked(): void {
        if (this.sectionId && this.isSectionExpanded !== false) {
        const subsectionDivId = this.element.nativeElement.querySelector(this.sectionId);
        if (subsectionDivId) {
            this.expandAncestorsForElement(subsectionDivId);
            this.jumpTo(subsectionDivId);
            this.isSectionExpanded = false;
        }
        }
    }

    onClick(event) {
        var targetSectionlink;
        var contentLink = event.target;
        if (contentLink != undefined) {
            var subsectionDivId = this.element.nativeElement.querySelector(contentLink.getAttribute('href'));
            this.element.nativeElement.querySelectorAll('[href="' + contentLink.getAttribute('href') + '"]')
                .forEach(elem => {
                    if (elem.hasAttribute('data-toggle')) { targetSectionlink = elem }
                })
            if (targetSectionlink.parentElement.parentElement.getAttribute('class') != "swapa-contract p-0") {
                var parentSectionlink = targetSectionlink.parentElement.parentElement.previousElementSibling;
                var parentSectionDivId = targetSectionlink.parentElement.parentElement;
                this.expandSectionLink(targetSectionlink, "h4");
                this.expandSectionLink(parentSectionlink, "h2");
                this.expandSectionDiv(parentSectionDivId);
                this.expandSectionDiv(subsectionDivId);

                this.jumpTo(subsectionDivId);
            }
            else {  
                parentSectionlink = targetSectionlink;
                parentSectionDivId = targetSectionlink.nextSibling;
                this.expandParentSection(parentSectionlink, parentSectionDivId);
            }

        }
    }

    expandParentSection(link, divId) {
        this.expandSectionLink(link, "h2");
        this.expandSectionDiv(divId);
        this.jumpTo(divId);
    }

    expandSectionLink(section, header) {
        if (section.getAttribute('class') != "swapa-contract-header swapa-accordion-prefix " + header + " collapsed") {
            section.setAttribute('class', "swapa-contract-header swapa-accordion-prefix " + header + " collapsed");
        }

        if (section.getAttribute('aria-expanded') != 'true') {
            section.setAttribute('aria-expanded', 'true');
        }
    }

    expandSectionDiv(sectionDivId) {
        if (sectionDivId.getAttribute('class') != "collapse show") {
            sectionDivId.setAttribute('class', 'collapse show');
        }
    }

    @HostListener('click') onClicks() { 
        
        var element = event.target as HTMLElement;
        if (element.getAttribute('class') == 'contentlink') {
            this.renderer2.listen(element, 'click', () => {
                this.onClick(events);   
            });
            let events: Event = new Event('click');
            element.dispatchEvent(events);
        }   
    }   

    ngAfterContentChecked(): void {
        this.cdRef.detectChanges();
    }

    ngOnDestroy(): void {
        this.stopObservingMarks();
    }

    clearFilterCount(): void {
        this.index.count = 0;
        this.dataService.setCurrentPosition(this.index.count);
        this.filterMetadata.count = 0;
        this.dataService.setTotalSearchCount(this.filterMetadata.count);
        this.sectionCount.count = 0;
        this.MatchDetails = [];
        this.initialLoad = true;
    }

    public expandSections(): void {
        var sections = this.element.nativeElement.querySelectorAll('.swapa-body > .swapa-contract > .swapa-contract > [aria-expanded=false]');
        if (sections.length > 0) {
            var header = this.element.nativeElement.querySelectorAll('.swapa-contract-header')
            this.setAttribute(header, "aria-expanded", true);
            var subSection = this.element.nativeElement.querySelectorAll('.swapa-contract .collapse');
            this.setAttribute(subSection, "class", "collapse show");
        }
    }

    toggleAllSections(event) {
        if (event != null) {
            var expanded = this.element.nativeElement.querySelectorAll('.swapa-body > .swapa-contract > .swapa-contract > [aria-expanded=true]').length > 0;
            this.expanded = !this.expanded;
            if (expanded != undefined && expanded != null) {
                var subSection = this.element.nativeElement.querySelectorAll('.swapa-contract .collapse');
                var header2 = this.element.nativeElement.querySelectorAll('.swapa-body > .swapa-contract > .swapa-contract > .swapa-contract-header')
                var header4 = this.element.nativeElement.querySelectorAll('.swapa-body > .swapa-contract >.swapa-contract > div >.swapa-contract > .swapa-contract-header')
                this.setAttribute(subSection, "class", expanded ? "collapse" : "collapse show");
                this.setAttribute(header2, "aria-expanded", expanded ? false : true);
                this.setAttribute(header2, "class", expanded ? "swapa-contract-header swapa-accordion-prefix h2" : "swapa-contract-header swapa-accordion-prefix h2 collapsed");
                this.setAttribute(header4, "aria-expanded", expanded ? false : true);
                this.setAttribute(header4, "class", expanded ? "swapa-contract-header swapa-accordion-prefix h4" : "swapa-contract-header swapa-accordion-prefix h4 collapsed");
            }
        }
    }

    public setAttribute(element, attr, val): void {
        if (element != null) {
            for (var item = 0; item < element.length; item++) {
                {
                    element[item].setAttribute(attr, val);
                }
            }
        }
    }

  /* ---------- Navigation (Find Next / Prev) ---------- */

  public findNext(): void {
    const marks = this.getAllMarks();
    if (!marks.length) return;

    // Increment and wrap (1-based index)
    this.index.count += 1;
    this.index.count = this.index.count > this.filterMetadata.count ? 1 : this.index.count;

    this.dataService.setCurrentPosition(this.index.count);

    // Highlight based on 0-based array index
    this.updateActiveHighlight(this.index.count - 1);
  }

  public findPrev(): void {
    const marks = this.getAllMarks();
    if (!marks.length) return;

    // Decrement and wrap (1-based index)
    this.index.count -= 1;
    this.index.count = this.index.count <= 0 ? this.filterMetadata.count : this.index.count;

    this.dataService.setCurrentPosition(this.index.count);

    // Highlight based on 0-based array index
    this.updateActiveHighlight(this.index.count - 1);

  }

  /* ---------- Highlight Activation ---------- */

  private updateActiveHighlight(index: number): void {
    const marks = this.getAllMarks();
    if (!marks.length) return;

    marks.forEach(mark => {
      mark.classList.remove('swapa-contract-active');
      if (!mark.classList.contains('swapa-contract-highlight')) {
        mark.classList.add('swapa-contract-highlight');
      }
    });

    const activeMark = marks[index];
    if (!activeMark) return;

    activeMark.classList.remove('swapa-contract-highlight');
    activeMark.classList.add('swapa-contract-active');

    this.expandAncestorsForElement(activeMark);
    this.jumpTo(activeMark);
  }

  private getAllMarks(): HTMLElement[] {
    return Array.from(
      this.element.nativeElement.querySelectorAll('mark.swapa-contract-highlight, mark.swapa-contract-active')
    ) as HTMLElement[];
  }

  /* ---------- DOM Observing ---------- */

  private startObservingMarks(position = 0): void {
    this.stopObservingMarks();
    const root = this.element.nativeElement;
    const config = { childList: true, subtree: true };

    this.mutationObserver = new MutationObserver(() => {
      const marks = this.getAllMarks();
      if (marks.length > 0) {
        this.updateActiveHighlight(Math.min(position, marks.length - 1));
      }
    });

    this.mutationObserver.observe(root, config);
  }

  private stopObservingMarks(): void {
    if (this.mutationObserver) {
      this.mutationObserver.disconnect();
      this.mutationObserver = null;
    }
  }

  /* ---------- Section Expansion & Scrolling ---------- */

  private expandAncestorsForElement(el: HTMLElement): void {
    let parent = el.closest('.collapse');
    while (parent) {
      parent.classList.add('show');
      const header = parent.previousElementSibling as HTMLElement;
      if (header && header.getAttribute('aria-expanded') === 'false') {
        header.setAttribute('aria-expanded', 'true');
      }
      parent = parent.parentElement?.closest('.collapse') || null;
    }
  }

  private jumpTo(el: HTMLElement): void {
    setTimeout(() => {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 100);
  }

    public expand(position): void {
        if (position != null || this.element.nativeElement.querySelectorAll('.swapa-body > .swapa-contract > .swapa-contract > [aria-expanded=false]').length > 0) {
            this.expanded = true;
        }
    }

    private find(increment: number) {
        if (this.searchText) {
            //this.matchCount = this.highlight.highlight(this.searchText, this.caseSensitive);
            this.index.count += increment;

            this.index.count = this.index.count <= 0 ? this.filterMetadata.count : this.index.count;
            this.index.count = this.index.count > this.filterMetadata.count ? 1 : this.index.count;
            this.dataService.setCurrentPosition(this.index.count);

            var that = this;

            if (this.filterMetadata.count > 0) {

                //that.sectionCount.count = 0
                var activePosition;
                this.dataService.getContractDetails().subscribe((data: ContractDetails) => {
                    this.contractSections = data['ContractSections'];
                    this.contractSections.forEach(sec => {
                        sec.ContractItems.forEach(items => {
                            items.ContractItemBodyString = this.sanitizer.bypassSecurityTrustHtml(items.ContractItemBodyString) as string
                            // items.ContractItemBody.Fragments.forEach(Fragment => { Fragment.InternalFormat = this.sanitizer.bypassSecurityTrustHtml(Fragment.InternalFormat) as string }
                            // )
                        })
                    })
                    for (var secItems = 0; secItems < this.contractSections.length; secItems++) {
                        for (var sec = 0; sec < that.MatchDetails.length; sec++) {
                            for (var item = 0; item < that.MatchDetails[sec].TotalHighlight.length; item++) {
                                if ((that.index.count - 1) == that.MatchDetails[sec].TotalHighlight[item]["highlight"]) {
                                    activePosition = that.MatchDetails[sec].TotalHighlight[item]["key"];
                                    that.sectionCount.count = sec;
                                }
                            }
                        }
                        if (activePosition != undefined) {
                            let finalvalue = that.formatHtml;
                            finalvalue.forEach((format: ElementRef) => {
                                var text = that.highlightCount.transform(format.nativeElement.innerHTML, that.searchText, that.sectionCount.count, that.MatchDetails, that.filterMetadata.count, that.index.count, that.initialLoad = false,format);
                                if (text.changingThisBreaksApplicationSecurity != undefined) {
                                    format.nativeElement.innerHTML = text.changingThisBreaksApplicationSecurity
                                }
                                else
                                    format.nativeElement.innerHTML = text;
                            });

                            let sectionValue = that.sectionHtml;
                            sectionValue.forEach((section: ElementRef) => {
                                var text = that.highlightCount.transform(section.nativeElement.innerHTML, that.searchText, that.sectionCount.count, that.MatchDetails, that.filterMetadata.count, that.index.count, that.initialLoad = false, section);
                                if (text.changingThisBreaksApplicationSecurity != undefined) {
                                    section.nativeElement.innerHTML = text.changingThisBreaksApplicationSecurity
                                }
                                else
                                    section.nativeElement.innerHTML = text;
                            });

                            let subsectionValue = that.itemHtml;
                            subsectionValue.forEach((subsect: ElementRef) => {
                                var text = that.highlightCount.transform(subsect.nativeElement.innerHTML, that.searchText, that.sectionCount.count, that.MatchDetails, that.filterMetadata.count, that.index.count, that.initialLoad = false, subsect);
                                if (text.changingThisBreaksApplicationSecurity != undefined) {
                                    subsect.nativeElement.innerHTML = text.changingThisBreaksApplicationSecurity
                                }
                                else
                                    subsect.nativeElement.innerHTML = text;
                            });
                            break;
                        }
                    }
                });
            }
        }
    }

    myfunction(id) {
        this.popupName = this.element.nativeElement.querySelector(`#name-${id}`).textContent;
        let eleRef = this.element.nativeElement.querySelector(`#${id}`);
        eleRef.querySelector('.swapa-top-shortcut').setAttribute('hidden','');
        this.modalBody = eleRef.innerHTML;
        this.toggleModalDisplay = "block";
        this.element.nativeElement.querySelector('#contractModal').setAttribute('class', 'modal fade show');
    }

    sectionScroll(id) {
            if (this.currentSectionId != "#" + id) {
                this.sectionIdStack.push(this.currentSectionId);
                this.element.nativeElement.querySelector('#back-' + id).removeAttribute('hidden', true);
            }
            this.sectionId = "#" + id;
            this.isSectionExpanded = true;
            this.currentSectionId = this.sectionId;
            if (this.sectionIdStack.length > 1) {
                for (var i = 0; i < this.sectionIdStack.length; i++) {
                    var sectionId = this.sectionIdStack[i].replace('#', '');
                    if (this.currentSectionId != this.sectionIdStack[i]) {
                        this.element.nativeElement.querySelector('#back-' + sectionId).setAttribute('hidden', true);
                    }
                }
            }
    }

    closePopup() {
        this.toggleModalDisplay = "none";
        this.element.nativeElement.querySelector('#contractModal').setAttribute('class', 'modal fade');
    }

    validatePageName(title) {
        let year = title.replace(/[^0-9]/g, '')
        return year == '' ? false : year < 2020 ;
    }

    navigateBack(): void {
        let divId;
        if (this.sectionIdStack.length > 0) {
            const lastSectionId = this.sectionIdStack[this.sectionIdStack.length - 1];
            this.sectionIdStack.pop();
            let section = this.element.nativeElement.querySelector(this.sectionId);
            let isExpanded = section.classList.contains('show');
            let toggleElement = this.element.nativeElement.querySelector(`a[href="${this.sectionId}"]`);
            if (toggleElement) {
                toggleElement.setAttribute('aria-expanded', !isExpanded.toString());
            }            
            section.setAttribute('aria-expanded', !isExpanded);
            section.classList.toggle('show', !isExpanded);
            divId = this.sectionId;
            this.sectionId = lastSectionId;
            this.currentSectionId = this.sectionId;
            this.isSectionExpanded = true;
        }
        this.element.nativeElement.querySelector('#back-' + divId.replace('#', '')).setAttribute('hidden', true);
        if (this.sectionIdStack.length > 0) {
            this.element.nativeElement.querySelector('#back-' + this.sectionId.replace('#', '')).removeAttribute('hidden', true);
        }
    }

    updateSectionId(id) {
        this.currentSectionId = "#" + id;
    }
}
